(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adv-featured-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAdvOffer(root) {
    root.querySelectorAll('.adv-swatch:not([data-adv-sw-init])').forEach(function (btn) {
      btn.setAttribute('data-adv-sw-init', '');
      btn.addEventListener('click', function () {
        var sid = btn.dataset.section;
        var variantId = btn.dataset.variantId;
        var variantName = btn.dataset.variantName;
        var variantImg = btn.dataset.variantImg;
        var price = parseInt(btn.dataset.variantPrice, 10);
        var compare = parseInt(btn.dataset.variantCompare, 10);
        var sec = document.getElementById('shopify-section-' + sid);
        if (!sec) sec = btn.closest('.shopify-section');
        if (!sec) return;

        sec.querySelectorAll('.adv-swatch').forEach(function (s) {
          s.classList.remove('active');
          s.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('active');
        btn.setAttribute('aria-pressed', 'true');

        var nameEl = sec.querySelector('#adv-swatch-name-' + sid);
        if (nameEl) nameEl.textContent = variantName || '';

        var variantInput = sec.querySelector('#adv-variant-' + sid);
        if (variantInput) variantInput.value = variantId;

        if (variantImg) {
          var mainImg = sec.querySelector('#adv-main-img-' + sid);
          if (mainImg) mainImg.src = variantImg;
          sec.querySelectorAll('.adv-thumb').forEach(function (t) { t.classList.remove('active'); });
        }

        var priceEl = sec.querySelector('.adv-price-sale');
        if (priceEl && price) {
          priceEl.textContent = (price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        }
        var compareEl = sec.querySelector('.adv-price-compare');
        if (compareEl) {
          if (compare && compare > price) {
            compareEl.style.display = '';
            compareEl.textContent = (compare / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
          } else {
            compareEl.style.display = 'none';
          }
        }
      });
    });

    root.querySelectorAll('.adv-thumb:not([data-adv-th-init])').forEach(function (btn) {
      btn.setAttribute('data-adv-th-init', '');
      btn.addEventListener('click', function () {
        var src = btn.dataset.src;
        var mainId = btn.dataset.mainId;
        if (!src || !mainId) return;
        var mainImg = document.getElementById(mainId);
        if (mainImg) mainImg.src = src;
        var thumbs = btn.closest('.adv-offer-thumbs');
        if (thumbs) thumbs.querySelectorAll('.adv-thumb').forEach(function (t) { t.classList.remove('active'); });
        btn.classList.add('active');
      });
    });

    root.querySelectorAll('.adv-ifaq-btn:not([data-adv-faq-init])').forEach(function (btn) {
      btn.setAttribute('data-adv-faq-init', '');
      btn.addEventListener('click', function () {
        var item = btn.closest('.adv-ifaq-item');
        var isOpen = item.classList.contains('open');
        var faqList = btn.closest('.adv-inline-faq');
        if (faqList) faqList.querySelectorAll('.adv-ifaq-item.open').forEach(function (el) { el.classList.remove('open'); el.querySelector('.adv-ifaq-btn').setAttribute('aria-expanded', 'false'); });
        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  if (document.readyState !== 'loading') {
    initAdvOffer(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () { initAdvOffer(document); });
  }
  document.addEventListener('shopify:section:load', function (e) { initAdvOffer(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-faq"]) return;
  try {
    
  (function () {
    function initFaq(list) {
      list.querySelectorAll('.afaq-q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          var answer   = btn.nextElementSibling;
          if (expanded) {
            btn.setAttribute('aria-expanded', 'false');
            answer.hidden = true;
          } else {
            btn.setAttribute('aria-expanded', 'true');
            answer.hidden = false;
          }
        });
      });
    }
    function boot() {
      document.querySelectorAll('[data-afaq]').forEach(function (el) {
        if (el.dataset.afaqInit) return;
        el.dataset.afaqInit = '1';
        initFaq(el);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    function initUpsellSliders() {
      document.querySelectorAll('.cro-upsell-slider-wrap').forEach(function (wrap) {
        var slider = wrap.querySelector('[data-upsell-slider]');
        var dotsEl = wrap.querySelector('[data-upsell-dots]');
        if (!slider || !dotsEl) return;
        var slides = slider.querySelectorAll('.cro-upsell-slide');
        if (slides.length <= 1) return;
        dotsEl.innerHTML = '';
        slides.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.className = 'cro-upsell-dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Slide ' + (i + 1));
          dot.addEventListener('click', function () {
            slider.scrollTo({ left: slider.offsetWidth * i, behavior: 'smooth' });
          });
          dotsEl.appendChild(dot);
        });
        slider.addEventListener('scroll', function () {
          var idx = Math.round(slider.scrollLeft / slider.offsetWidth);
          dotsEl.querySelectorAll('.cro-upsell-dot').forEach(function (d, i) {
            d.classList.toggle('is-active', i === idx);
          });
        }, { passive: true });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initUpsellSliders);
    } else {
      initUpsellSliders();
    }
    document.addEventListener('cart:updated', initUpsellSliders);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colorway-theater"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCw(root) {
      (root.querySelectorAll ? root : document).querySelectorAll('[data-cw-podium]').forEach(function (podium) {
      if (podium._cwInit) return;
      podium._cwInit = true;

      var slides = Array.prototype.slice.call(podium.querySelectorAll('.cw-slide'));
      var wrap = podium.closest('.colorway-theater');
      var dotsWrap = wrap.querySelector('[data-cw-dots]');
      var label = wrap.querySelector('[data-cw-label]');
      if (!slides.length) return;
      var N = slides.length;
      var activeIdx = parseInt(podium.getAttribute('data-default-idx'), 10) || 0;

      slides.forEach(function (slide, i) {
        var btn = document.createElement('button');
        btn.className = 'cw-dot';
        btn.setAttribute('aria-label', slide.dataset.color);
        btn.style.color = slide.dataset.hex;
        var inner = document.createElement('span');
        inner.className = 'cw-dot-inner';
        inner.style.background = slide.dataset.hex;
        btn.appendChild(inner);
        btn.addEventListener('click', function () { activate(i); });
        dotsWrap.appendChild(btn);
      });

      slides.forEach(function (slide, i) {
        slide.addEventListener('click', function () {
          if (i !== activeIdx) {
            activate(i);
          } else {
            var url = slide.dataset.url;
            if (url) window.location.href = url;
          }
        });
      });

      function activate(idx) {
        activeIdx = ((idx % N) + N) % N;
        slides.forEach(function (slide, i) {
          var raw = ((i - activeIdx) % N + N) % N;
          var pos = raw > Math.floor(N / 2) ? raw - N : raw;
          slide.dataset.pos = pos;
        });
        var dots = dotsWrap.querySelectorAll('.cw-dot');
        dots.forEach(function (dot, i) {
          dot.classList.toggle('active', i === activeIdx);
          dot.style.borderColor = i === activeIdx ? slides[i].dataset.hex : 'transparent';
        });
        if (label) label.textContent = slides[activeIdx].dataset.color;
        // Sync ATC variant input
        var variantInput = wrap.querySelector('[data-cw-variant]');
        if (variantInput) {
          var vId = slides[activeIdx].dataset.variant;
          if (vId) variantInput.value = vId;
        }
        // Sync product link href (per-colorway URL, fallback to section-level)
        var cwLink = wrap.querySelector('[data-cw-link]');
        if (cwLink) {
          var linkUrl = slides[activeIdx].dataset.url || podium.dataset.fallbackUrl;
          if (linkUrl) cwLink.href = linkUrl;
        }
        // Pointer cursor on active slide when it has a URL
        slides.forEach(function (slide, i) {
          slide.style.cursor = (i === activeIdx && slide.dataset.url) ? 'pointer' : '';
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  activate((activeIdx - 1 + N) % N);
        if (e.key === 'ArrowRight') activate((activeIdx + 1) % N);
      });

      var dragStartX = 0, isDragging = false;
      function dragStart(x) { dragStartX = x; isDragging = true; podium.classList.add('is-dragging'); }
      function dragEnd(x) {
        if (!isDragging) return;
        isDragging = false;
        podium.classList.remove('is-dragging');
        var dx = x - dragStartX;
        if (Math.abs(dx) > 50) {
          if (dx < 0) activate((activeIdx + 1) % N);
          else        activate((activeIdx - 1 + N) % N);
        }
      }
      podium.addEventListener('touchstart',  function (e) { dragStart(e.touches[0].clientX); }, { passive: true });
      podium.addEventListener('touchmove',   function (e) { e.preventDefault(); }, { passive: false });
      podium.addEventListener('touchend',    function (e) { dragEnd(e.changedTouches[0].clientX); }, { passive: true });
      podium.addEventListener('touchcancel', function () { isDragging = false; podium.classList.remove('is-dragging'); }, { passive: true });
      podium.addEventListener('mousedown', function (e) { dragStart(e.clientX); e.preventDefault(); });
      window.addEventListener('mousemove', function () {});
      window.addEventListener('mouseup', function (e) { if (isDragging) dragEnd(e.clientX); });

      activate(activeIdx);
    });
    }
    if (document.readyState !== 'loading') {
      initCw(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () { initCw(document); });
    }
    document.addEventListener('shopify:section:load', function (e) { initCw(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complementary-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.currentScript.closest('.shopify-section');
    if (!section) return;
    section.querySelectorAll('.comp-atc-form').forEach(form => {
      form.addEventListener('submit', e => {
        e.preventDefault();
        const fd = new FormData(form);
        const btn = form.querySelector('button');
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
        fetch(form.action + '.js', { method: 'POST', body: fd })
          .then(r => r.json())
          .then(() => {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:open'));
          })
          .catch(console.error)
          .finally(() => { if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; } });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["founder-video"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.currentScript.closest('.shopify-section');
    if (!section) return;
    const id = section.id.replace('shopify-section-', '');
    const btn = section.querySelector('.founder-play');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const ytId = btn.dataset.youtube;
      if (!ytId) return;
      const thumb = section.querySelector('#founder-thumb-' + id);
      const embed = section.querySelector('#founder-embed-' + id);
      const iframe = section.querySelector('#founder-iframe-' + id);
      if (!embed || !iframe) return;
      iframe.src = 'https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0';
      if (thumb) thumb.querySelector('.founder-thumb-overlay').style.display = 'none';
      embed.style.display = 'block';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fritaire-nontoxic"]) return;
  try {
    
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.ftr-atp-compare-btn');
    if (!btn) return;
    var box = btn.closest('.ftr-atp-compare');
    var isOpen = box.classList.contains('open');
    box.classList.toggle('open', !isOpen);
    btn.setAttribute('aria-expanded', String(!isOpen));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["functions-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.functions').forEach(function (section) {
      if (section._fnInit) return;
      section._fnInit = true;
      var btns = Array.prototype.slice.call(section.querySelectorAll('[data-fn2-list] .fn2-btn'));
      var slides = Array.prototype.slice.call(section.querySelectorAll('[data-fn2-slides] .fn2-slide'));
      var n = btns.length;
      if (!n) return;
      var active = 0, timer;
      function setActive(idx) {
        active = ((idx % n) + n) % n;
        btns.forEach(function (b, i) { b.classList.toggle('is-active', i === active); });
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === active); });
      }
      btns.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          clearInterval(timer);
          setActive(i);
          timer = setInterval(function () { setActive(active + 1); }, 4200);
        });
      });
      timer = setInterval(function () { setActive(active + 1); }, 4200);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function initFritaireHeader() {
    const shell = document.querySelector('.header-shell');
    const header = document.getElementById('header');
    if (!header || header.dataset.initialized) return;
    header.dataset.initialized = 'true';

    const slides = document.querySelectorAll('.promo__slide');
    if (slides.length > 1) {
      let cur = 0;
      let timer;
      function goTo(n) {
        const prev = cur;
        cur = (n + slides.length) % slides.length;
        if (prev === cur) return;
        slides[prev].classList.add('is-leaving');
        slides[prev].classList.remove('is-active');
        requestAnimationFrame(() => slides[cur].classList.add('is-active'));
        setTimeout(() => {
          const s = slides[prev];
          s.style.transition = 'none';
          s.classList.remove('is-leaving');
          void s.offsetWidth;
          s.style.transition = '';
        }, 430);
      }
      function start() {
        timer = setInterval(() => goTo(cur + 1), 4000);
      }
      function reset() {
        clearInterval(timer);
        start();
      }
      document.querySelector('[data-promo-prev]')?.addEventListener('click', () => {
        goTo(cur - 1);
        reset();
      });
      document.querySelector('[data-promo-next]')?.addEventListener('click', () => {
        goTo(cur + 1);
        reset();
      });
      start();
    }

    const items = document.querySelectorAll('.nav__item[data-mega]');
    const panels = document.querySelectorAll('[data-mega-panel]');
    let menuTimer;
    const closeAll = () => panels.forEach((p) => p.classList.remove('is-open'));
    const openPanel = (key) => {
      closeAll();
      const p = document.querySelector('[data-mega-panel="' + key + '"]');
      if (p) p.classList.add('is-open');
    };
    items.forEach((item) => {
      const key = item.dataset.mega;
      item.addEventListener('mouseenter', () => {
        clearTimeout(menuTimer);
        openPanel(key);
      });
      item.addEventListener('mouseleave', () => {
        menuTimer = setTimeout(closeAll, 180);
      });
      item.querySelector('.nav__link').addEventListener('click', (e) => {
        e.preventDefault();
        const p = document.querySelector('[data-mega-panel="' + key + '"]');
        p.classList.contains('is-open') ? closeAll() : openPanel(key);
      });
    });
    panels.forEach((p) => {
      p.addEventListener('mouseenter', () => clearTimeout(menuTimer));
      p.addEventListener('mouseleave', () => {
        menuTimer = setTimeout(closeAll, 180);
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });

    let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 12);
      if (shell) {
        if (y > lastY && y > 80) {
          shell.classList.add('is-hidden');
          closeAll();
        } else if (y < lastY) {
          shell.classList.remove('is-hidden');
        }
      }
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    const drawer = document.querySelector('[data-mobile-drawer]');
    if (!drawer) return;
    const sections = drawer.querySelectorAll('.mobile-nav__section');
    const openDrawer = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-drawer-open');
    };
    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-drawer-open');
    };
    document.querySelectorAll('[data-drawer-open]').forEach((t) => t.addEventListener('click', openDrawer));
    drawer.querySelectorAll('[data-drawer-close]').forEach((t) => t.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
    sections.forEach((section) => {
      const btn = section.querySelector('.mobile-nav__trigger');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const wasOpen = section.classList.contains('is-open');
        sections.forEach((s) => {
          s.classList.remove('is-open');
          s.querySelector('.mobile-nav__trigger')?.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          section.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFritaireHeader);
  } else {
    initFritaireHeader();
  }
  document.addEventListener('shopify:section:load', initFritaireHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["press-quotes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mqs-section').forEach(function (section) {
      var vp = section.querySelector('.mqs-viewport');
      if (!vp || vp._mqsInit) return;
      vp._mqsInit = true;
      var startX, scrollStart, isDragging = false, moved = false;

      vp.addEventListener('mousedown', function (e) {
        isDragging = true; moved = false;
        startX = e.clientX;
        scrollStart = vp.scrollLeft;
        vp.classList.add('is-dragging');
        e.preventDefault();
      });
      window.addEventListener('mousemove', function (e) {
        if (!isDragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        vp.scrollLeft = scrollStart - dx;
      });
      window.addEventListener('mouseup', function () {
        if (!isDragging) return;
        isDragging = false;
        vp.classList.remove('is-dragging');
      });
      vp.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);

      var dots = Array.prototype.slice.call(section.querySelectorAll('[data-mqs-dots] .mqs-dot'));
      if (dots.length) {
        vp.addEventListener('scroll', function () {
          var max = vp.scrollWidth - vp.clientWidth;
          if (!max) return;
          var page = Math.round((vp.scrollLeft / max) * (dots.length - 1));
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === page); });
        }, { passive: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ── Slider instance factory (thumbnail_slider layout) ── */
    function initSlider(sfx) {
      var mainImg   = document.getElementById('pdpMainImg-' + sfx);
      var mainVideo = document.getElementById('pdpMainVideo-' + sfx);
      var thumbs    = Array.from(document.querySelectorAll('[data-slider="' + sfx + '"].pdp-thumb'));
      var sdots     = Array.from(document.querySelectorAll('[data-slider="' + sfx + '"].pdp-sdot'));
      var idx = 0;

      function activate(btn, i) {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        sdots.forEach(function (d) { d.classList.remove('active'); });
        btn.classList.add('active');
        if (sdots[i]) sdots[i].classList.add('active');
        idx = i;
        var type = btn.dataset.type || 'image';
        if (type === 'video' && btn.dataset.video) {
          if (mainImg) mainImg.style.display = 'none';
          if (mainVideo) { mainVideo.style.display = 'block'; mainVideo.src = btn.dataset.video; mainVideo.play(); }
        } else {
          if (mainVideo) { mainVideo.pause(); mainVideo.style.display = 'none'; mainVideo.src = ''; }
          if (mainImg && btn.dataset.src) {
            mainImg.style.opacity = '0';
            var src = btn.dataset.src;
            setTimeout(function () { mainImg.style.display = 'block'; mainImg.src = src; mainImg.style.opacity = '1'; }, 140);
          }
        }
      }

      thumbs.forEach(function (btn, i) { btn.addEventListener('click', function () { activate(btn, i); }); });
      sdots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.dataset.idx, 10);
          if (thumbs[i]) activate(thumbs[i], i);
        });
      });

      /* Prev/next arrows */
      var mainWrap = document.getElementById('pdpMainWrap-' + sfx);
      document.querySelectorAll('[data-slider="' + sfx + '"].pdp-main-btn--prev').forEach(function (btn) {
        btn.addEventListener('click', function () { if (thumbs[idx - 1]) activate(thumbs[idx - 1], idx - 1); });
      });
      document.querySelectorAll('[data-slider="' + sfx + '"].pdp-main-btn--next').forEach(function (btn) {
        btn.addEventListener('click', function () { if (thumbs[idx + 1]) activate(thumbs[idx + 1], idx + 1); });
      });

      /* Touch swipe */
      if (mainWrap && thumbs.length > 1) {
        var startX = 0;
        mainWrap.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        mainWrap.addEventListener('touchend', function (e) {
          var diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) < 40) return;
          var next = diff > 0 ? Math.min(idx + 1, thumbs.length - 1) : Math.max(idx - 1, 0);
          if (next !== idx && thumbs[next]) activate(thumbs[next], next);
        }, { passive: true });
      }
    }

    /* ── Carousel instance factory ── */
    function initCarousel(sfx) {
      var carousel = document.getElementById('pdpCarousel-' + sfx);
      var track    = document.getElementById('pdpCarouselTrack-' + sfx);
      var dots     = Array.from(document.querySelectorAll('[data-carousel="' + sfx + '"].pdp-carousel-dot'));
      var cthumbs  = Array.from(document.querySelectorAll('[data-carousel="' + sfx + '"].pdp-cthumb'));
      var cIdx     = 0;
      var total    = dots.length || cthumbs.length || (track ? track.children.length : 0);
      var useScroll = sfx === 'mb';

      /* Mobile: set slide widths so scroll-snap works, update dots on scroll */
      if (useScroll && carousel && track) {
        function setSlideSizes() {
          var w = carousel.offsetWidth;
          Array.from(track.children).forEach(function (s) { s.style.width = w + 'px'; });
          track.style.width = (w * track.children.length) + 'px';
        }
        setSlideSizes();
        window.addEventListener('resize', setSlideSizes);
        carousel.addEventListener('scroll', function () {
          var w = carousel.offsetWidth || 1;
          var n = Math.round(carousel.scrollLeft / w);
          if (n !== cIdx && n >= 0 && n < total) {
            cIdx = n;
            dots.forEach(function (d) { d.classList.remove('active'); });
            if (dots[cIdx]) dots[cIdx].classList.add('active');
            cthumbs.forEach(function (t) { t.classList.remove('active'); });
            if (cthumbs[cIdx]) cthumbs[cIdx].classList.add('active');
          }
        }, { passive: true });
      }

      function go(n) {
        cIdx = Math.max(0, Math.min(n, total - 1));
        if (useScroll && carousel) {
          carousel.scrollTo({ left: cIdx * carousel.offsetWidth, behavior: 'smooth' });
        } else if (track) {
          track.style.transform = 'translateX(' + (-cIdx * 100) + '%)';
        }
        dots.forEach(function (d) { d.classList.remove('active'); });
        if (dots[cIdx]) dots[cIdx].classList.add('active');
        cthumbs.forEach(function (t) { t.classList.remove('active'); });
        if (cthumbs[cIdx]) cthumbs[cIdx].classList.add('active');
      }

      dots.forEach(function (dot) { dot.addEventListener('click', function () { go(parseInt(dot.dataset.idx, 10)); }); });
      cthumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.idx, 10)); }); });
      document.querySelectorAll('[data-carousel="' + sfx + '"].pdp-carousel-btn--prev').forEach(function (btn) {
        btn.addEventListener('click', function () { go(cIdx - 1); });
      });
      document.querySelectorAll('[data-carousel="' + sfx + '"].pdp-carousel-btn--next').forEach(function (btn) {
        btn.addEventListener('click', function () { go(cIdx + 1); });
      });

      /* Touch swipe only for JS-transform instances (desktop carousel) */
      if (track && !useScroll) {
        var startX = 0;
        track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
        track.addEventListener('touchend', function (e) {
          var diff = startX - e.changedTouches[0].clientX;
          if (Math.abs(diff) < 40) return;
          go(diff > 0 ? cIdx + 1 : cIdx - 1);
        }, { passive: true });
      }
    }

    /* ── Mobile thumbnail_slider: scroll-snap track wired to thumbnails ── */
    function initMbThumbSlider(sfx) {
      var track = document.getElementById('pdpMbTrack-' + sfx);
      if (!track) return;
      var thumbs = Array.from(document.querySelectorAll('[data-mbtrack="' + sfx + '"].pdp-thumb'));
      var sdots  = Array.from(document.querySelectorAll('[data-mbtrack="' + sfx + '"].pdp-sdot'));
      var total  = track.children.length;

      function setActive(i) {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        sdots.forEach(function (d) { d.classList.remove('active'); });
        if (thumbs[i]) {
          thumbs[i].classList.add('active');
          thumbs[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
        if (sdots[i]) sdots[i].classList.add('active');
      }

      track.addEventListener('scroll', function () {
        var w = track.offsetWidth;
        if (!w) return;
        var i = Math.round(track.scrollLeft / w);
        if (i >= 0 && i < total) setActive(i);
      }, { passive: true });

      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = parseInt(btn.dataset.idx, 10);
          track.scrollTo({ left: i * track.offsetWidth, behavior: 'smooth' });
        });
      });

      sdots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.dataset.idx, 10);
          track.scrollTo({ left: i * track.offsetWidth, behavior: 'smooth' });
        });
      });
    }

    /* Boot whichever instances exist */
    ['dt', 'mb'].forEach(function (sfx) {
      if (document.querySelector('[data-slider="' + sfx + '"]')) initSlider(sfx);
      if (document.getElementById('pdpCarouselTrack-' + sfx)) initCarousel(sfx);
      if (document.getElementById('pdpMbTrack-' + sfx)) initMbThumbSlider(sfx);
    });

    /* ── Qty stepper ── */
    var qtyInput = document.getElementById('pdpQtyInput');
    var minus = document.getElementById('pdpQtyMinus');
    var plus  = document.getElementById('pdpQtyPlus');
    if (minus) minus.addEventListener('click', function () { if (qtyInput) qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1); });
    if (plus)  plus.addEventListener('click',  function () { if (qtyInput) qtyInput.value = parseInt(qtyInput.value, 10) + 1; });

    /* ── ATC loading state ── */
    var buyForm = document.getElementById('pdp-form');
    if (buyForm) {
      buyForm.addEventListener('submit', function () {
        var btn = buyForm.querySelector('.pdp-atc:not(:disabled)');
        if (!btn) return;
        btn.classList.add('is-loading');
        var timer = setTimeout(function () { btn.classList.remove('is-loading'); }, 3500);
        document.addEventListener('cart:updated', function () { clearTimeout(timer); btn.classList.remove('is-loading'); }, { once: true });
      });
    }

    /* ── Color swatch hover ── */
    var colorName = document.getElementById('pdpColorName');
    document.querySelectorAll('.pdp-swatch').forEach(function (a) {
      a.addEventListener('mouseenter', function () { if (colorName) colorName.textContent = a.dataset.name || a.title; });
      a.addEventListener('mouseleave', function () {
        var active = document.querySelector('.pdp-swatch.active');
        if (colorName && active) colorName.textContent = active.dataset.name || active.title;
      });
    });

    /* ── Mini review slider ── */
    var mrSlider = document.getElementById('pdpMrSlider');
    if (mrSlider) {
      var mrSlides = mrSlider.querySelectorAll('.pdp-mr-slide');
      var mrDotsWrap = document.getElementById('pdpMrDots');
      var mrIdx = 0;
      var mrDots = [];
      mrSlides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.className = 'pdp-mr-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', 'Review ' + (i + 1));
        dot.addEventListener('click', function () { mrGo(i); });
        mrDotsWrap.appendChild(dot);
        mrDots.push(dot);
      });
      function mrGo(n) {
        mrSlides[mrIdx].classList.remove('active');
        if (mrDots[mrIdx]) mrDots[mrIdx].classList.remove('active');
        mrIdx = n;
        mrSlides[mrIdx].classList.add('active');
        if (mrDots[mrIdx]) mrDots[mrIdx].classList.add('active');
      }
      if (mrSlides.length > 1) setInterval(function () { mrGo((mrIdx + 1) % mrSlides.length); }, 4500);
      var mrTouchX = 0;
      mrSlider.addEventListener('touchstart', function (e) { mrTouchX = e.touches[0].clientX; }, { passive: true });
      mrSlider.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - mrTouchX;
        if (Math.abs(dx) > 40) mrGo((mrIdx + (dx < 0 ? 1 : mrSlides.length - 1)) % mrSlides.length);
      });
    }

    /* ── Collapsible rows ── */
    document.querySelectorAll('.pdp-bf-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pdp-bf-item');
        var isOpen = item.classList.contains('open');
        document.querySelectorAll('.pdp-bf-item.open').forEach(function (el) { el.classList.remove('open'); });
        if (!isOpen) item.classList.add('open');
      });
    });

    /* ── Sticky ATC bar ── */
    var sBar    = document.getElementById('pdpStickyBar');
    var sBarBtn = document.getElementById('pdpSbarBtn');
    var sBuyBlock = document.querySelector('.pdp-block--buy');
    if (sBar && sBuyBlock) {
      /* Sync variant ID into sticky form when main form changes */
      var mainVarId   = document.getElementById('pdp-variant-id');
      var stickyVarId = document.getElementById('pdpStickyVariantId');
      if (mainVarId && stickyVarId) {
        document.addEventListener('variant:changed', function (e) {
          if (e.detail && e.detail.variant) stickyVarId.value = e.detail.variant.id;
        });
      }

      /* Show only after main ATC scrolls above viewport */
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sBar.classList.remove('is-visible');
            sBar.setAttribute('aria-hidden', 'true');
          } else if (entry.boundingClientRect.top < 0) {
            sBar.classList.add('is-visible');
            sBar.setAttribute('aria-hidden', 'false');
          }
        });
      }, { threshold: 0 }).observe(sBuyBlock);

      /* Color dropdown — navigate to selected product URL */
      var sBarSelect = document.getElementById('pdpSbarSelect');
      if (sBarSelect) {
        sBarSelect.addEventListener('change', function () {
          window.location.href = this.value;
        });
      }

      /* Scroll-to-PDP action */
      if (sBarBtn && sBarBtn.type === 'button') {
        sBarBtn.addEventListener('click', function () {
          sBuyBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      /* Loading state for sticky form */
      var stickyForm = document.getElementById('pdpStickyForm');
      if (stickyForm) {
        stickyForm.addEventListener('submit', function () {
          var btn = stickyForm.querySelector('.pdp-sbar__atc:not(:disabled)');
          if (!btn) return;
          btn.classList.add('is-loading');
          var t = setTimeout(function () { btn.classList.remove('is-loading'); }, 3500);
          document.addEventListener('cart:updated', function () {
            clearTimeout(t); btn.classList.remove('is-loading');
          }, { once: true });
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTestimonials(root) {
      root.querySelectorAll('.tstm-grid:not([data-tstm-init])').forEach(function (grid) {
        grid.setAttribute('data-tstm-init', '');
        var section = grid.closest('.shopify-section');
        var dotsContainer = section ? section.querySelector('.tstm-dots') : null;
        if (!dotsContainer) return;
        var cards = Array.prototype.slice.call(grid.querySelectorAll('.tstm-card'));
        cards.forEach(function (card, index) {
          var dot = document.createElement('div');
          dot.className = 'tstm-dot' + (index === 0 ? ' active' : '');
          dot.addEventListener('click', function () {
            card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          });
          dotsContainer.appendChild(dot);
        });
        var dots = Array.prototype.slice.call(dotsContainer.querySelectorAll('.tstm-dot'));
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var idx = cards.indexOf(entry.target);
              dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
            }
          });
        }, { root: grid, threshold: 0.6 });
        cards.forEach(function (card) { observer.observe(card); });
      });
    }
    if (document.readyState !== 'loading') {
      initTestimonials(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () { initTestimonials(document); });
    }
    document.addEventListener('shopify:section:load', function (e) { initTestimonials(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-stories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.ugc').forEach(function (section) {
      if (section._ugcInit) return;
      section._ugcInit = true;

      var track = section.querySelector('[data-ugc-track]');
      if (track) {
        var next = section.querySelector('[data-ugc-next]');
        var prev = section.querySelector('[data-ugc-prev]');
        if (next) next.addEventListener('click', function () { track.scrollLeft += 216; });
        if (prev) prev.addEventListener('click', function () { track.scrollLeft -= 216; });
      }

      var PLAY_ICON  = '<svg width="14" height="16" viewBox="0 0 14 16" fill="none"><path d="M1.5 1.5l11 6.5-11 6.5V1.5z" fill="#fff"/></svg>';
      var PAUSE_ICON = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><rect x="1" y="0" width="4" height="14" rx="1" fill="#fff"/><rect x="9" y="0" width="4" height="14" rx="1" fill="#fff"/></svg>';
      var MUTED_ICON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M11 5L6 9H2v6h4l5 4V5z" fill="#fff"/><line x1="23" y1="9" x2="17" y2="15" stroke="#fff" stroke-width="2.5" stroke-linecap="round"/><line x1="17" y1="9" x2="23" y2="15" stroke="#fff" stroke-width="2.5" stroke-linecap="round"/></svg>';
      var SOUND_ICON = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M11 5L6 9H2v6h4l5 4V5z" fill="#fff"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07M19.07 4.93a10 10 0 0 1 0 14.14" stroke="#fff" stroke-width="2" stroke-linecap="round"/></svg>';

      var globalMuted = true;
      var cards = Array.prototype.slice.call(section.querySelectorAll('.vc-card'));

      function stopAll(exceptVideo) {
        cards.forEach(function (c) {
          var v = c.querySelector('video');
          if (!v || v === exceptVideo) return;
          v.pause();
          c.classList.remove('is-playing', 'vid-active');
          if (c._hideTimer) { clearTimeout(c._hideTimer); c._hideTimer = null; }
          var pb = c.querySelector('.vc-play');
          if (pb) { pb.innerHTML = PLAY_ICON; pb.setAttribute('aria-label', 'Play'); }
        });
      }

      cards.forEach(function (card) {
        var thumb = card.querySelector('.vc-thumb');
        var playBtn = card.querySelector('.vc-play');
        var video = thumb ? thumb.querySelector('video') : null;
        if (!video) return;

        video.muted = true;

        var muteBtn = document.createElement('button');
        muteBtn.className = 'vc-mute';
        muteBtn.innerHTML = MUTED_ICON;
        muteBtn.setAttribute('aria-label', 'Unmute');
        thumb.appendChild(muteBtn);

        var progressEl = document.createElement('div');
        progressEl.className = 'vc-progress';
        var barEl = document.createElement('div');
        barEl.className = 'vc-progress-bar';
        progressEl.appendChild(barEl);
        thumb.appendChild(progressEl);

        function startVideo() {
          stopAll(video);
          video.muted = globalMuted;
          muteBtn.innerHTML = globalMuted ? MUTED_ICON : SOUND_ICON;
          muteBtn.setAttribute('aria-label', globalMuted ? 'Unmute' : 'Mute');
          video.play();
          card.classList.add('is-playing');
          card.classList.remove('vid-active');
          playBtn.innerHTML = PAUSE_ICON;
          playBtn.setAttribute('aria-label', 'Pause');
          if (card._hideTimer) clearTimeout(card._hideTimer);
          card._hideTimer = setTimeout(function () { card.classList.add('vid-active'); }, 500);
        }
        function pauseVideo() {
          video.pause();
          if (card._hideTimer) { clearTimeout(card._hideTimer); card._hideTimer = null; }
          card.classList.remove('is-playing', 'vid-active');
          playBtn.innerHTML = PLAY_ICON;
          playBtn.setAttribute('aria-label', 'Play');
        }

        card.addEventListener('click', function (e) {
          if (e.target.closest('.vc-mute')) return;
          if (video.paused) startVideo(); else pauseVideo();
        });
        muteBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          globalMuted = !globalMuted;
          video.muted = globalMuted;
          muteBtn.innerHTML = globalMuted ? MUTED_ICON : SOUND_ICON;
          muteBtn.setAttribute('aria-label', globalMuted ? 'Unmute' : 'Mute');
        });
        video.addEventListener('timeupdate', function () {
          if (video.duration) barEl.style.width = (video.currentTime / video.duration * 100) + '%';
        });
        video.addEventListener('ended', function () { pauseVideo(); barEl.style.width = '0%'; });
        card._pauseVideo = pauseVideo;
      });

      if ('IntersectionObserver' in window) {
        var vcObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting && entry.target._pauseVideo) {
              var v = entry.target.querySelector('video');
              if (v && !v.paused) entry.target._pauseVideo();
            }
          });
        }, { threshold: 0.25 });
        cards.forEach(function (card) { vcObserver.observe(card); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whats-included"] && !Shopify.designMode) return;
  try {
    
(function () {
  var orbitData = [
    { name: 'Rotisserie Kit',  desc: 'Your home Fry-tisserie! Roast and rotate kebabs, whole chickens, meats, all juicy and crisped to perfection.' },
    { name: 'Motor',           desc: 'Powers the Rotisserie Spit and Tumbling Basket for 360° even heat circulation.' },
    { name: 'Grabber Tool',    desc: 'Safely remove the Rotisserie or Tumbling Basket from the air fryer with ease.' },
    { name: 'Air Stand',       desc: 'One rack, endless options. Fish, snacks, baked goods, and everything in between.' },
    { name: 'Tumbling Basket', desc: 'Set it and walk away. The Tumbling Basket keeps food moving as it cooks, so every piece comes out evenly crisp without flipping or shaking.' }
  ];
  var N = orbitData.length;

  function getOffsets() {
    return window.innerWidth <= 700
      ? [270, 342, 54, 126, 198]
      : [180, 252, 324, 36, 108];
  }

  var active = 4;
  var throttled = false;
  var autoTimer;

  var orbitEl = document.getElementById('box-orbit');
  if (!orbitEl) return;

  var chips  = orbitEl.querySelectorAll('.orbit-chip-wrap');
  var nameEl = document.getElementById('box-acc-name');
  var descEl = document.getElementById('box-acc-desc');
  var dotsEl = document.getElementById('box-dots');

  var dots = orbitData.map(function (_, i) {
    var d = document.createElement('button');
    d.className = 'box-dot';
    d.setAttribute('aria-label', orbitData[i].name);
    d.addEventListener('click', function () { clearInterval(autoTimer); setActive(i); });
    dotsEl.appendChild(d);
    return d;
  });

  function setActive(idx) {
    active = ((idx % N) + N) % N;
    var scale = orbitEl.offsetWidth / 520;
    var R = 208 * scale;
    var OFFSET_ANGLES = getOffsets();

    chips.forEach(function (chip, i) {
      var offset = ((i - active + N) % N);
      var deg = OFFSET_ANGLES[offset];
      var rad = deg * Math.PI / 180;
      chip.style.transform = 'translate(' + (Math.cos(rad) * R) + 'px, ' + (Math.sin(rad) * R) + 'px)';
      chip.classList.toggle('is-active', offset === 0);
      chip.style.opacity = [1, 0.5, 0.2, 0.2, 0.5][offset];
    });

    nameEl.style.opacity = '0';
    descEl.style.opacity = '0';
    clearTimeout(nameEl._ft);
    nameEl._ft = setTimeout(function () {
      nameEl.textContent = orbitData[active].name;
      descEl.textContent = orbitData[active].desc;
      nameEl.style.opacity = '1';
      descEl.style.opacity = '1';
    }, 180);

    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === active); });
  }

  orbitEl.addEventListener('wheel', function (e) {
    e.preventDefault();
    if (throttled) return;
    throttled = true;
    clearInterval(autoTimer);
    setTimeout(function () { throttled = false; }, 600);
    setActive(e.deltaY > 0 ? active + 1 : active - 1);
  }, { passive: false });

  chips.forEach(function (chip, i) {
    chip.addEventListener('click', function () { clearInterval(autoTimer); setActive(i); });
  });

  autoTimer = setInterval(function () { setActive(active + 1); }, 3800);
  window.addEventListener('resize', function () { setActive(active); });
  setActive(active);
})();

  } catch(e) { console.error(e); }
})();
})();
